/** Extra detail only — headings/labels stay visible in the UI */

export const SUB_PARTY_MODAL_HELP =
  'You can still edit each amount if you need a different split. Each invoice line can belong to only one sub party.';

export const SUB_PARTY_NO_LINES_HELP =
  'Add items to the invoice on the main screen first, then return here to split the total.';

export const SUB_PARTY_AMOUNT_HELP =
  'Fills automatically when you check lines below. Edit anytime if the split should differ from line totals.';

export const SUB_PARTY_AMOUNT_DETAIL_HELP =
  'When every invoice line is assigned across sub parties, invoice round-off may be added to one row so sub-party totals match the rounded grand total.';

export const SUB_PARTY_SYNC_HELP =
  'Recalculates every sub party amount from its checked lines only (does not change which lines are selected).';

export const SUB_PARTY_ASSIGN_LINES_HELP =
  'Lines already assigned to another sub party are hidden here until you uncheck them on that sub party.';

export const SUB_PARTY_NO_AVAILABLE_LINES_HELP =
  'Uncheck a line on the sub party above to move it here.';

export const SUB_PARTY_ROUND_OFF_HELP =
  'Applied to one sub party when all lines are assigned so the sum matches the invoice grand total after rounding.';

export const SUB_PARTY_TOTAL_MISMATCH_HELP =
  'Adjust amounts or line assignments until the difference is zero, then click Apply.';

export function subPartyHiddenLinesHelp(hiddenCount) {
  return `${hiddenCount} line${hiddenCount === 1 ? ' is' : 's are'} on other sub parties. Uncheck there first to assign here.`;
}
